import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpPatternInObjectValidator
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * Validates if a defined string value of the ngModel object fulfills the pattern
     *
     * (If model is a string use ng-pattern instead!)
     *
     * @attr {Date} ngModel model is an object
     * @attr {Date} pkpPatternInObjectValidator defined string value which shall be checked if model is not null
     * for example ['value','text'] if modelValue is an object with contains a object with name 'value' with property 'text'
     *
     * @attr {string} pkpPattern regular expression which shall be checked
     *
     * @author somarten.btc
     */
    angular
        .module('app')
        .directive('pkpPatternInObjectValidator', pkpPatternInObjectValidator);

    function pkpPatternInObjectValidator() {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            ngModelCtrl.$validators.pkpPatternInObjectValidator = validate;

            var pattern = new RegExp(attr.pkpPattern);
            var refArray = scope.$eval(attr.pkpPatternInObjectValidator);

            function validate(modelValue, viewValue) {
                if (!viewValue) {
                    return true;
                }

                var value = viewValue;

                //run through object structure
                var i = 0;
                for (; i < refArray.length; i++) {
                    value = value[refArray[i]];
                    if (!value) {
                        return true;
                    }
                }

                return pattern.test(value);
            }
        }
    }
})();
